
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { NewsForm } from "./NewsForm";
import { NewsArticle } from "./NewsManagement";

interface NewsFormSectionProps {
  article: Omit<NewsArticle, "id">;
  onChange: (article: Omit<NewsArticle, "id">) => void;
  onSubmit: () => void;
}

export function NewsFormSection({ article, onChange, onSubmit }: NewsFormSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Προσθήκη Νέου Άρθρου</CardTitle>
      </CardHeader>
      <CardContent>
        <NewsForm
          article={article}
          onChange={onChange}
          onSubmit={onSubmit}
        />
      </CardContent>
    </Card>
  );
}
